/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Navigate,
  Route,
  Routes,
} from "react-router-dom";
import TagManager from "react-gtm-module";
import { Auth, Hub } from "aws-amplify";
import { useDispatch, useSelector } from "react-redux";
import { loader } from "graphql.macro";
import Header from "./components/header/Header";
import SideNav from "./components/sideNav/SideNav";
import SearchClaim from "./components/searchClaim/SearchClaim";
import Conversation from "./components/conversation/Conversation";
import { doLogin, getAdjusterSchedule } from "./store/actions/userActions";
import { updateUser } from "./store/action-creators/userActionCreator";
import {
  isNotEmpty,
  getSnackbarVariant,
  getBatchResponseMessage,
  getBatchResponseTitle,
  formatNewLinesInHtml,
  twoStringsAreEqual,
  isActiveParticipant,
  setAlert,
} from "./utils/utilities";
import ConversationControl from "./components/conversationControl/ConversationControl";
import getConfig from "./aws-exports";
import {
  Env,
  SESSION_ERROR,
  SNACKBAR,
  LOGOUT_TIME,
  SEND,
  RECEIVED,
} from "./utils/constants";
import { SAAlert, SASnackbar } from "@saux/design-system-react";
import snackbarOpen, {
  snackbarClose,
} from "./store/action-creators/snackbarActionCreators";
import { executeGraphqlSubscribe } from "./graphql/api";
import NoAccessPage from "./components/noAccessPage/NoAccessPage";
import ConversationViewer from "./components/conversationViewer/ConversationViewer";
import "./App.css";
import ArchivedConversations from "./components/archivedConversations/ArchivedConversations";
import {
  updateBatchType,
  updateFromAdjuster,
  updateToAdjuster,
} from "./store/action-creators/adjusterActionCreator";
import alertOpen from "./store/action-creators/alertActionCreator";
import styled from "styled-components";
import useIdleTimer from "./useIdleTimer";
import UserProfile from "./components/userProfile/UserProfile";
import fetchConversations, {
  fetchUnreadMessagesCountById,
} from "./store/actions/conversationActions";

const getAdjusterUpdates = loader(
  "./graphql/subscriptions/getAdjusterUpdates.graphql"
);
const getCurrentAdjusterUpdates = loader(
  "./graphql/subscriptions/getCurrentAdjusterUpdates.graphql"
);
const receiveMessagesSubscription = loader(
  "./graphql/subscriptions/receiveMessagesByAdjusterId.graphql"
);

const awsExports: any = getConfig(process.env.REACT_APP_ENV as Env);

function App() {
  const Timer = useIdleTimer(LOGOUT_TIME);
  const [signedIn, setSignedIn] = useState<boolean>(false);
  const [displayModal, setDisplayModal] = useState(false);
  const [receivedConversationsCount, setReceivedConversationsCount] = useState(
    0
  );
  const [path, setPath] = useState("");
  const [batchResponse, setBatchResponse] = useState<any>({});
  const [isAdjusterApiCalled, setAdjusterApiCalled] = useState(false);
  const [isValidUser, setValidUser] = useState(false);
  const [notificationSound, setNotificationSound] = useState("");
  const [
    isBrowserNotificationDisabled,
    setIsBrowserNotificationDisabled,
  ] = useState(true);
  const user = useSelector((state: any) => state.user);
  const {
    open: isDownload,
    message: alertMessage,
    action: alertAction,
    url,
  } = useSelector((state: any) => state.alert);
  const { open, message, type, title } = useSelector(
    (state: any) => state.snackbar
  );
  const { batchType } = useSelector((state: any) => state.adjusters);
  const dispatch = useDispatch();
  let messageSubscription: any;
  let userEmail: any = [];
  //let sound:any=[];

  const DownloadAlert = styled(SAAlert)`
    width: 25vw;
    z-index: 999;
    margin-left: 42vw;
    margin-top: 70vh;
    margin-bottom: 4vh;
    position: absolute;
  `;

  const downloadPdf = () => {
    window.open(url);
  };

  useEffect(() => {
    Hub.listen("auth", ({ payload }) => {
      switch (payload.event) {
        case "signOut":
          setSignedIn(false);
          break;
        default:
      }
    });
  }, []);

  useEffect(() => {
    if (Timer === 0) {
      //signOut();
      window.location.reload();
    }
  }, [Timer]);

  const doRedirectToRequestedPage = () => {
    const redirectLocation = sessionStorage.getItem("redirectLocation");
    sessionStorage.removeItem("redirectLocation");
    if (redirectLocation && redirectLocation !== window.location.href) {
      window.location.assign(redirectLocation);
    }
  };

  const checkUser = () => {
    Auth.currentAuthenticatedUser()
      .then((user) => {
        // if (isLoginAndAdjusterIdUsersAreSame(user.email)) {
        setSignedIn(true);
        user = {
          ...user,
          fullName: user.attributes.name + " " + user.attributes.given_name,
          email: user.attributes.email.toLowerCase(),
          userName: user.username,
        };
        dispatch(updateUser(user));
        userEmail.push(user.email);
        TagManager.initialize({
          gtmId: awsExports.gtmId,
          dataLayer: {
            csrId: user.userName,
          },
        });
        dispatch(
          getAdjusterSchedule(
            { adjusterId: user.email },
            (res: any) => {
              setAdjusterApiCalled(true);
              setValidUser(true);
              // setGlobalState("notificationSound", res.data.getAdjusterSchedule[0].adjusterSetting.notificationSoundValue)
              setNotificationSound(
                res.data.getAdjusterSchedule[0].adjusterSetting
                  .notificationSoundValue
              );
              //sound.push(res.data.getAdjusterSchedule[0].adjusterSetting.notificationSoundValue);
            },
            (error: any) => {
              setAdjusterApiCalled(true);
              setValidUser(false);
            }
          )
        );
        subscribeToGetAdjusterUpdates(user.email);
        subscribeToGetCurrentAdjusterUpdates(user.email);
      })
      .catch((error: any) => {
        if (error?.includes("not authenticated")) {
          if (window && window.location) {
            if (window?.location?.search.indexOf("?code=") === -1) {
              doLogin();
            }
          }
        }
      });
  };

  useEffect(() => {
    const redirectLocation = sessionStorage.getItem("redirectLocation");
    if (!redirectLocation) {
      sessionStorage.setItem("redirectLocation", window.location.href);
    }
    if (signedIn) {
      doRedirectToRequestedPage();
      // runOutTimer();
    } else {
      checkUser();
    }
  }, [signedIn]);

  const subscribeToGetAdjusterUpdates = (adjusterId: string) => {
    executeGraphqlSubscribe(getAdjusterUpdates, {
      adjusterId: adjusterId,
    }).subscribe({
      next: ({ provider, value }: any) => {
        let response = value?.data?.onAdjusterUpdates;
        if (window.location.pathname === "/message")
          setReceivedConversationsCount(response?.success);
      },
      error: ({ error, provider }: any) => {
        handleSubscriptionError(error);
      },
    });
  };

  const subscribeToGetCurrentAdjusterUpdates = (adjusterId: string) => {
    executeGraphqlSubscribe(getCurrentAdjusterUpdates, {
      currentAdjusterId: adjusterId,
    }).subscribe({
      next: ({ provider, value }: any) => {
        let response = value?.data?.onAdjusterUpdates;
        setBatchResponse(response);
      },
      error: ({ error, provider }: any) => {
        setBatchResponse({ error: error });
        handleSubscriptionError(error);
      },
    });
  };

  useEffect(() => {
    if (isNotEmpty(batchResponse) && isNotEmpty(batchType)) {
      if (batchResponse?.error) {
        dispatch(
          snackbarOpen({
            open: true,
            message: batchResponse.error.message,
            type: SNACKBAR.ERROR,
          })
        );
      } else {
        dispatch(
          snackbarOpen({
            open: true,
            title: getBatchResponseTitle(),
            message: getBatchResponseMessage(batchResponse),
            type: SNACKBAR.SUCCESS,
          })
        );
      }
      setTimeout(() => {
        dispatch(updateFromAdjuster(null));
        dispatch(updateToAdjuster(null));
        dispatch(updateBatchType(null));
        setBatchResponse(null);
      }, 10000);
    }
  }, [batchResponse, batchType]);

  const handleSubscriptionError = (error: any) => {
    if (error && error.errors && error.errors[0]) {
      let message = error.errors[0].message;
      if (message.includes(SESSION_ERROR)) {
        doLogin();
      }
      console.log(error.message);
    }
  };

  async function signOut() {
    try {
      await Auth.signOut({ global: true });
    } catch (error: any) {
      if (error.message.includes("Access Token has been revoked")) {
        Auth.signOut();
      }
      console.error("Error signing out: ", error);
    }
  }

  function handleClose() {
    dispatch(snackbarClose({ open: false, message: "", type: "", title: "" }));
  }

  return signedIn && isNotEmpty(user) && isAdjusterApiCalled ? (
    isValidUser ? (
      <Router>
        <div className="App">
          <div className="header">
            <Header
              displayModal={displayModal}
              setDisplayModal={setDisplayModal}
              signOut={signOut}
            />
          </div>
          <div className="main-body">
            <UserProfile
              displayModal={displayModal}
              setDisplayModal={setDisplayModal}
              notificationSound={notificationSound}
              setNotificationSound={setNotificationSound}
              isBrowserNotificationDisabled={isBrowserNotificationDisabled}
              setIsBrowserNotificationDisabled={
                setIsBrowserNotificationDisabled
              }
            />
            <div style={{ pointerEvents: "none" }}>
              <SASnackbar
                open={open}
                variant={type}
                position="bottom"
                title={title ? title : getSnackbarVariant(type)}
                subtitle={message}
                //closeable
                onClose={handleClose}
                //zIndex={0}
                autoHideDuration={5000}
              />
            </div>
            {isDownload && (
              <DownloadAlert
                severity="success"
                role="alert"
                actionLabel={alertAction}
                onActionClick={downloadPdf}
                closeable
                onClose={() => {
                  dispatch(
                    alertOpen({
                      open: false,
                    })
                  );
                }}
              >
                {alertMessage}
              </DownloadAlert>
            )}

            <div style={{ display: "flex", height: "100%" }}>
              <SideNav path={path} setPath={setPath} />
              <div className="content-body">
                <Routes>
                  <Route
                    path="/message"
                    element={
                      <Conversation
                        receivedConversationsCount={receivedConversationsCount}
                        isBrowserNotificationDisabled={
                          isBrowserNotificationDisabled
                        }
                        notificationSound={notificationSound}
                      />
                    }
                  />
                  <Route
                    path="/search"
                    element={<SearchClaim setPath={setPath} />}
                  />
                  <Route
                    path="/conversation-control"
                    element={<ConversationControl />}
                  />
                  <Route
                    path="/conversation-viewer"
                    element={
                      <ConversationViewer
                        notificationSound={notificationSound}
                        isBrowserNotificationDisabled={
                          isBrowserNotificationDisabled
                        }
                      />
                    }
                  />
                  <Route
                    path="/archived-conversations"
                    element={<ArchivedConversations setPath={setPath} />}
                  />
                  <Route path="/" element={<Navigate to="/message" />} />
                </Routes>
              </div>
            </div>
          </div>
        </div>
      </Router>
    ) : (
      <NoAccessPage />
    )
  ) : (
    <div className="loader" />
  );
}

export default App;
